import {
    GET_REPORTS_LIST_ACTION,
    DOWNLOAD_REPORTS_LIST_ACTION,
    DOWNLOAD_REPORTS_LIST_START,
    DOWNLOAD_REPORTS_LIST_COMPLETE,
    CLIENT_ANALYSIS_ACTION,
    REVENUE_ANALYSIS_ACTION,
    TRANSACTION_ANALYSIS_ACTION,
    USER_STATS_ACTION,
    SALARY_REVENUE_ANALYSIS_ACTION,
    COMPANY_ANALYSIS_ACTION,
    RESET_ANALYSIS_ERROR,
} from "./types";

export const getReportsListAction = (filters) => ({
    type: GET_REPORTS_LIST_ACTION,
    payload: { filters }
})

export const downloadReportsListAction = (data, fileName) => ({
    type: DOWNLOAD_REPORTS_LIST_ACTION,
    payload: { data, fileName },
});

export const downloadReportsListStart = () => ({
    type: DOWNLOAD_REPORTS_LIST_START,
});

export const downloadReportsListComplete = () => ({
    type: DOWNLOAD_REPORTS_LIST_COMPLETE,
});

// ── /reports/* analysis endpoints ────────────────────────────────────────
// One dispatch per endpoint. Component code should reach only for these
// (never the API layer directly) so a reviewer sees the same dispatch shape
// used by every other saga-driven feature in this app.
export const getClientAnalysisAction = (payload) => ({
    type: CLIENT_ANALYSIS_ACTION,
    payload,
});

export const getRevenueAnalysisAction = (payload) => ({
    type: REVENUE_ANALYSIS_ACTION,
    payload,
});

export const getTransactionAnalysisAction = (payload) => ({
    type: TRANSACTION_ANALYSIS_ACTION,
    payload,
});

export const getUserStatsAction = (payload) => ({
    type: USER_STATS_ACTION,
    payload,
});

export const getSalaryRevenueAnalysisAction = (payload) => ({
    type: SALARY_REVENUE_ANALYSIS_ACTION,
    payload,
});

export const getCompanyAnalysisAction = (payload) => ({
    type: COMPANY_ANALYSIS_ACTION,
    payload,
});

// analysis: one of client/revenue/transaction/user_stats/salary_revenue/company
// — the reducer scopes the clear to that slice so a stale error on one report
// doesn't clear another's.
export const resetAnalysisErrorAction = (analysis) => ({
    type: RESET_ANALYSIS_ERROR,
    analysis,
});